import { createBrowserRouter } from 'react-router-dom';

import ClosureNotice from '@/pages/ClosureNotice';

import { createWrappedElement } from './utils';

// Build the router with consolidated routes
export const router = createBrowserRouter([
  {
    path: '/',
    element: createWrappedElement(ClosureNotice),
  },
  {
    path: '*',
    element: createWrappedElement(ClosureNotice),
  },
]);
